module.exports = __webpack_public_path__ + "img/product-img_2.f1f28699.png";